import { css } from "emotion";

const labelStyle = css({
  display: "block",
  marginBottom: 4
});
const InputLabel = ({ label }) => {
  return <label className={labelStyle}>{label}</label>;
};

export default InputLabel;
